console.log("retrocomp-blocks-with-icons.js");

const legacyBlocks = document.querySelectorAll('.colored-paragraphs-withicon.bloc__bg__colore');

if (legacyBlocks.length === 0) {
    console.log("Aucun bloc legacy détecté, script ignoré.");
} else {
    console.log(`${legacyBlocks.length} bloc(s) legacy détecté(s).`);

    legacyBlocks.forEach(function(block) {

        // Remplace le title par data-block-type
        const title = block.getAttribute('title');
        if (title) {
            block.setAttribute('data-block-type', title);
            block.removeAttribute('title');
        }

        // Migration de l'icône
        const iconDiv = block.querySelector('[class*="icon-"]');
        if (!iconDiv) return;

        const iconClass = Array.from(iconDiv.classList).find(c => c.startsWith('icon-'));
        if (!iconClass) return;

        const svgWrapper = document.createElement('div');
        svgWrapper.className = 'colored-paragraphs-withicon--icon';
        svgWrapper.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="icon ${iconClass}" aria-hidden="true">
                <use href="/static/icons/uga.svg#${iconClass}"></use>
            </svg>
        `;

        iconDiv.replaceWith(svgWrapper);
        console.log(`Bloc migré : icône "${iconClass}", data-block-type="${title}"`);
    });
}